import { extractKeyedSearchTerms } from "encamp-omnisearch/src/utils/keyedSearchTerms";
import { DateTime } from "luxon";

export function withDefaultAuditInvoiceDate(search: string, today = DateTime.local()): string {
  const [terms] = extractKeyedSearchTerms(search);
  if (terms.some(({ key }) => key === "invoiceDate")) return search;
  const startDate = today.minus({ months: 3 }).startOf("month").toISODate();
  const endDate = today.endOf("month").toISODate();
  const range = `${startDate}..${endDate}`;
  return `invoiceDate:${range}${search ? ` ${search}` : ""}`;
}

export function auditFacilityId(search: string): string | undefined {
  const [terms] = extractKeyedSearchTerms(search);
  return terms.find(({ key }) => key === "facilityId")?.value[0];
}

export function auditReportSearch(params: URLSearchParams): string {
  const next = new URLSearchParams(params);
  next.delete("lineId");
  return next.toString();
}

/** Only hide date expressions the range picker can represent completely. */
export function auditInvoiceDateRange(search: string) {
  const [terms] = extractKeyedSearchTerms(search);
  const dates = terms.filter(({ key }) => key === "invoiceDate");
  const value = dates.length === 1 && dates[0]?.value.length === 1 ? dates[0].value[0] : undefined;
  const empty = { value: "", startDate: undefined, endDate: undefined };
  if (!value) return empty;
  const parts = value.includes("..") ? value.split("..") : [value, value];
  if (parts.length !== 2 || !parts[0] || !parts[1]) return empty;
  if (
    parts.some(
      (part) =>
        part &&
        (!/^\d{4}-\d{2}-\d{2}$/.test(part) || !DateTime.fromISO(part, { zone: "utc" }).isValid)
    )
  ) {
    return empty;
  }
  const [startDate, endDate] = parts;
  if (startDate && endDate && startDate > endDate) return empty;
  return { value, startDate: startDate || undefined, endDate: endDate || undefined };
}
